import(/* webpackMode: "eager" */ "/app/src/app/it-solutions/page.tsx");
